"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PPGrid = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("./styles");
//Componentes usados do Material UI
var core_1 = require("@material-ui/core");
//Componentes do Grid
var components_1 = __importDefault(require("./components"));
/**
 * Grid layout
 * @param {GridInterface} props Propriedades
 */
var PPGrid = function (_a) {
    var cssClass = _a.cssClass, props = __rest(_a, ["cssClass"]);
    var classes = (0, styles_1.useStyles)();
    var renderGrid = function (item, i) {
        return react_1.default.createElement(core_1.Grid, __assign({ item: true, key: i, xs: item.xs ? item.xs : item.width ? item.width : 12, sm: item.sm ? item.sm : item.width ? item.width : 12, md: item.md ? item.md : item.width ? item.width : 12, lg: item.lg ? item.lg : item.width ? item.width : 12, xl: item.xl ? item.xl : item.width ? item.width : 12 }, props), (0, components_1.default)(item, props.fields, props.readOnly, props.disabled));
    };
    var render = function () {
        var items = props.fields ? props.contents.map(function (item) {
            var field = props.fields.contents.find(function (field) { return field.id === item.id; });
            return __assign(__assign({}, item), field);
        }) : false;
        return (react_1.default.createElement(core_1.Grid, __assign({ container: true, spacing: 3, className: cssClass === "form" ? classes.form : cssClass !== "default" ? cssClass : classes.default }, props),
            props.fields ? items.map(function (item, i) { return (renderGrid(item, i)); })
                : props.contents.map(function (item, i) { return (renderGrid(item, i)); }),
            props.children));
    };
    var sizes = {
        lg: props.lg || 'auto',
        md: props.md || 'auto',
        sm: props.sm || 'auto',
        xl: props.xl || 'auto',
        xs: props.xs || 'auto'
    };
    var renderChildren = function () {
        if (props.container) {
            return props.contents || props.fields
                ? (render())
                : (react_1.default.createElement(core_1.Grid, __assign({}, props, sizes, { className: cssClass === "form" ? classes.formDad : cssClass !== "default" ? cssClass : classes.default }), props.children));
        }
        else {
            return props.contents || props.fields
                ? (render())
                : (react_1.default.createElement(core_1.Grid, __assign({}, props, sizes, { className: cssClass === "form" ? classes.formChildren : cssClass !== "default" ? cssClass : classes.default }), props.children));
        }
    };
    return renderChildren();
};
exports.PPGrid = PPGrid;
